'use strict'
module.exports = (typeof self === 'object' && self.self === self && self) ||
  (typeof global === 'object' && global.global === global && global) ||
  this



//////////////////
// WEBPACK FOOTER
// ./~/window-or-global/lib/index.js
// module id = 264
// module chunks = 0